import editorsOptions from './editorsOptions';
import EditorInput from '../../editorInputs/EditorInput';
import { Box, Flex, Select } from '@chakra-ui/react';
import EditorSubmenu from '../../editorInputs/EditorSubmenu';

const getEditor = ({ editorsOptions, componentName, propName }) => {
	if (editorsOptions[`${componentName}/${propName}`]) return editorsOptions[`${componentName}/${propName}`];
	if (editorsOptions[propName]) return editorsOptions[propName];
	return null;
};

const PropEditorElement = ({ arrayIndex, originalPropname, propName, props, componentId, componentName }) => {
	const propValue = props[propName];
	const editor = getEditor({ editorsOptions, componentName, propName });
	if (!editor && typeof propValue !== 'object') return null;

	if (typeof propValue == 'object') {
		return (
			<EditorSubmenu {...{ title: propName }}>
				{propValue &&
					Object.keys(propValue).map((subItem, index) => {
						const editorOptions = editorsOptions[subItem];
						if (!editorOptions && !editor) return;
						const { type: SubEditorComponent, getValues, tooltip } = editor ?? editorsOptions[subItem];
						const values = getValues({
							propName: subItem,
							propValue: propValue[subItem],
							componentName,
							objectName: propName,
						});
						return (
							<SubEditorComponent
								{...{
									arrayIndex,
									originalPropname,
									componentName,
									propValue: propValue[subItem],
									propName,
									title: subItem,
									componentId,
									tooltip,
									values,
								}}
								key={`sub-${subItem}-${index}-prop`}
							/>
						);
					})}
			</EditorSubmenu>
		);
	}

	let { type: EditorComponent, getValues, title, tooltip } = editor;

	let values = getValues({
		propValue,
		propName,
		componentName,
	});
	//fix temporario para solucionar conflito com icones na prop size, que existe em outros componentes como dropdown, mas para o icone deve ser input
	//A solução que tem hoje resolve exceções para outros componentes, mas nesse caso seria necessario adicionar um objeto para cada Icone no editorOptions
	//então essa solução continua sendo a mais limpa
	if (componentName?.includes('Icon')) {
		values = [{ placeholder: 'Ex: 40', value: Number(propValue) }];
		EditorComponent = EditorInput;
	}
	return (
		<EditorComponent
			{...{
				arrayIndex,
				originalPropname,
				componentName,
				propValue,
				propName,
				tooltip,
				title,
				values,
				componentId,
			}}
		/>
	);
};

export default PropEditorElement;
